import { ChangeDetectionStrategy, Component, EventEmitter, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import moment from 'moment';
import { DaterangepickerDirective } from 'ngx-daterangepicker-material';
import { LanguageService } from '../../../language.service';

export interface Filters {
  starts_after?: startsAfterFilter;
  ends_before?: endsBeforeFilter;
}

export type startsAfterFilter = null | string;
export type endsBeforeFilter = null | string;

@Component({
  selector: 'app-date-picker',
  templateUrl: './date-picker.component.html',
  styleUrls: ['./date-picker.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class DatePickerComponent implements OnInit {
  @ViewChild(DaterangepickerDirective, { static: false }) picker: DaterangepickerDirective;
  @Output() rangeFilter = new EventEmitter<Filters>();
  @Output() reloadData = new EventEmitter<boolean>();
  @Output() clearData = new EventEmitter<boolean>();

  selected: any;
  right: string = 'right';
  alwaysShowCalendars: boolean;
  ranges: any = {
    'Today': [moment(), moment()],
    'Yesterday': [moment().subtract(1, 'days'), moment()],
    'Last 7 Days': [moment().subtract(6, 'days'), moment()],
    'Last 30 Days': [moment().subtract(29, 'days'), moment()],
    'Last 2 Months': [moment().subtract(58, 'days'), moment()],
    'Last 3 Months': [moment().subtract(3, 'months'), moment()]
    // 'This Month': [moment().startOf('month'), moment().endOf('month')],
    // 'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
  }
  locale: any = {
    format: 'YYYY-MM-DDTHH:mm:ss.SSSSZ',
    displayFormat: 'DD-MM-YYYY',
    separator: ' To ',
    cancelLabel: 'Cancel',
    applyLabel: 'Okay'
  }
  invalidDates: moment.Moment[] = [moment().add(2, 'days'), moment().add(3, 'days'), moment().add(5, 'days')];

  isInvalidDate = (m: moment.Moment) => {
    return this.invalidDates.some(d => d.isSame(m, 'day'))
  }

  changeLang = false;
  rangeSelected = false;
  minDate = moment().subtract(3, 'months')
  maxDate = moment()

  constructor(private translateService: LanguageService) { }

  ngOnInit() {
    this.translateService.currentLanguage.subscribe(res => {
      if (res == 'en') {
        this.locale = {
          format: 'YYYY-MM-DDTHH:mm:ss.SSSSZ',
          displayFormat: 'DD-MM-YYYY',
          separator: ' To ',
          cancelLabel: 'Cancel',
          applyLabel: 'Okay'
        }
        this.ranges = {
          'Today': [moment(), moment()],
          'Yesterday': [moment().subtract(1, 'days'), moment()],
          'Last 7 Days': [moment().subtract(6, 'days'), moment()],
          'Last 30 Days': [moment().subtract(29, 'days'), moment()],
          'Last 2 Months': [moment().subtract(58, 'days'), moment()],
          'Last 3 Months': [moment().subtract(3, 'months'), moment()]
          // 'This Month': [moment().startOf('month'), moment().endOf('month')],
          // 'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
        }
      }
      else {
        this.locale = {
          format: 'DD-MM-YYYYTHH:mm:ss.SSSSZ',
          displayFormat: 'DD-MM-YYYY',
          separator: ' Έως ',
          cancelLabel: 'Ακύρωση',
          applyLabel: 'Εντάξει'
        }
        this.ranges = {
          'Σήμερα': [moment(), moment()],
          'Εχθές': [moment().subtract(1, 'days'), moment()],
          'Τελευταίες 7 Ημέρες': [moment().subtract(6, 'days'), moment()],
          'Τελευταίες 30 Ημέρες': [moment().subtract(29, 'days'), moment()],
          'Τελευταίοι 2 Μήνες': [moment().subtract(58, 'days'), moment()],
          'Τελευταίοι 3 Μήνες': [moment().subtract(3, 'months'), moment()]
          // 'This Month': [moment().startOf('month'), moment().endOf('month')],
          // 'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
        }
      }
    })
  }

  ngModelChange(e) {
    const start: startsAfterFilter = e.startDate !== null ? moment(e.startDate).format('YYYY-MM-DD') : e.startDate
    const end: endsBeforeFilter = e.endDate !== null ? moment(e.endDate).format('YYYY-MM-DD') : e.endDate

    const rangeFilter: Filters = { starts_after: start, ends_before: end }

    rangeFilter.starts_after !== null && rangeFilter.ends_before !== null ? this.rangeFilter.emit(rangeFilter) : null

    this.rangeSelected = rangeFilter.starts_after !== null && rangeFilter.ends_before !== null ? this.rangeSelected = true : this.rangeSelected = false;
  }

  clear() {
    this.picker.clear();
    this.rangeSelected = false;
    this.selected = undefined;
    this.clearData.emit(true)
  }
}
